
/* Search AutoComplete
------------------------------------------------ */
(function($) {

	function outputLi(result) {
		if(result.sub_title) {
			return '<li><a href="' + result.url + '">' + result.title + '<span class="link-subtitle">' + result.sub_title + '</span></a></li>';
		}
		return '<li><a href="' + result.url + '">' + result.title + '</a></li>';
	}

    $.fn.autoKomplete = function(options) {
		var el = this, keyTimer, previousValue;
		var btnIcon = el.siblings('button').find('i');

		var resultsEl = $('.search-dropdown-group-wrap');
		var resultsWrap = $('.search-dropdown-wrapper');
		var thisForm = $(el).closest('form');

		var opt = $.extend({
			type: false
        }, options );

		el.on('keyup', function(){

			if(previousValue != el.val()) {
				clearTimeout(keyTimer);

				if(el.val() && el.val().length >= 2) {
					keyTimer = setTimeout(getResults, 700);
				} else {
					btnIcon.removeClass('fa-spinner-third fa-spin').addClass('fa-magnifying-glass');
					resultsWrap.fadeOut(200);
					thisForm.addClass('no-live-search-results');
				}

			}
			previousValue = el.val();

		});

		function getResults() {
			btnIcon.removeClass('fa-magnifying-glass').addClass('fa-spinner-third fa-spin');
			btnIcon.closest('button').addClass('clear-filter-btn').attr('type', 'reset');

			var jsonURL = js_params.rest_url + 'mirick/search?term=' + el.val();

			$.getJSON(jsonURL, (results) => {

				var output = '';
				thisForm.addClass('no-live-search-results');

				if(results.people.length) {
					thisForm.removeClass('no-live-search-results');
					output += '<div class="search-result-group">';
					output += '<div class="group-title">People</div><ul class="people-result">';
					$.each(results.people, function(i, v){
						output += outputLi(v);
					});
					output += '</ul>';
					output += '</div>';
				}

				if(results.services.length) {
					thisForm.removeClass('no-live-search-results');
					output += '<div class="search-result-group">';
					output += '<div class="group-title">Services</div><ul class="services-result">';
					$.each(results.services, function(i, v){
						output += outputLi(v);
					});
					output += '</ul>';
					output += '</div>';
				}

				if(results.industries.length) {
					thisForm.removeClass('no-live-search-results');
					output += '<div class="search-result-group">';
					output += '<div class="group-title">Industries</div><ul class="industries-result">';
					$.each(results.industries, function(i, v){
						output += outputLi(v);
					});
					output += '</ul>';
					output += '</div>';
				}

				resultsEl.html(output);
				btnIcon.removeClass('fa-spinner-third fa-spin').addClass('fa-magnifying-glass');
				resultsWrap.fadeIn(200);
			});
		}
    };

}(jQuery));

(function ($) {
	// On Dom Ready
	$(function () {
		// Show search form
		$(".search-open").on("click", function (e) {
			e.preventDefault();
			openSearch();
		});

		// Hide search form when clicked outside
		$(document).on("click", function (e) {
			var $target = $(e.target);

			if (
				!$target.closest(".searchform").length &&
				!$target.hasClass("search-open") &&
				!$target.hasClass("fa-magnifying-glass")
			) {
				closeSearch();
			}
		});

		function openSearch() {
			$(".searchform").addClass("active");
			setTimeout(function () {
				$(".searchform input").focus();
			}, 300);
		}

		function closeSearch() {
			$(".searchform").removeClass("active");
			//$('.search-dropdown-wrapper').hide();
		}

		// Predictive Search
		$('.searchform input[name="s"]').autoKomplete();
	});
})(jQuery);
